import { Component, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BaseListComponent, DocumentService, PreviewDocument } from '../../common';
import { Dialog } from '../../common/dialog.service';
import { MatChipsModule } from '@angular/material/chips';
import { ChainDocument, ReportDocument } from '../../model';
import { ReportProductDocumentsComponent } from './report-product-documents.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-documents-dialog',
  templateUrl: 'documents-dialog.component.html',
  styleUrls: ['documents-dialog.component.scss'],
  providers: [{ provide: BaseListComponent, useExisting: DocumentsDialogComponent }],
  imports: [
    MatDialogModule,
    MatChipsModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    ReportProductDocumentsComponent,
    TranslateModule,
  ],
})
export class DocumentsDialogComponent implements OnInit {
  private documentService = inject(DocumentService);
  private dialog = inject(Dialog);
  data = inject<{
    documents: ChainDocument[];
  }>(MAT_DIALOG_DATA);

  preview: Record<string, PreviewDocument> = {};
  documents: ChainDocument[] = this.data.documents;

  async ngOnInit() {
    this.preview = await this.documentService.previewList(this.documents.map(({ id }) => id));
  }

  async openDocument(doc: ReportDocument | ChainDocument): Promise<void> {
    const response = await this.documentService.view(doc.id);
    if (!response?.body) {
      return;
    }
    await this.dialog.showPdf(doc.title || doc.type?.name || 'Document', response.body, {
      fileName: doc.fileName || `${doc.title || 'document'}.pdf`,
      mimeType: doc.fileType || response.body.type,
    });
  }
}
